module.exports = __webpack_public_path__ + "img/anatomy.83562849.png";